import { Dispatch } from 'redux';

import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { 
  getUserLocationsSuccess,
  getUserLocationsFailure,
  selectLocation
} from '../actions';
import { Location } from '../types';

// Initiator for fetching user locations
export const fetchUserLocations = (userId: string) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    try {
      // Get the loginToken from the Redux state
      const { auth } = getState();
      const loginToken = auth.loginToken;
      const { selectedLocation } = getState().location;

      // Construct the headers with X-Auth-Token
      const headers = {
        'X-Auth-Token': loginToken,
      };
      const response = await backend.get(
        `/user-service/api/v1/locations/user/${userId}`,
        { headers }
      );

      if (response.status === 200) {
        const locations: any = response.data;
        dispatch(getUserLocationsSuccess(locations));
        if (locations.length && !selectedLocation) {
          locations.map((location: Location) => {
            if (location.default) dispatch(selectLocation(location))
          })
        }
      } else {
        dispatch(getUserLocationsFailure('Failed to fetch user locations.'));
      }
    } catch (error) {
      console.error('Error fetching user locations:', error);
      dispatch(
        getUserLocationsFailure('An error occurred while fetching user locations.')
      );
    }
  };
};